import { SET_CONTENTFUL } from './types';

export function SetContentful(contentfulData){
  return dispatch => dispatch({type:SET_CONTENTFUL, payload:contentfulData})
}



// WEBPACK FOOTER //
// ./src/actions/contentful.js